export function handleCustomForms() {

  $('.form-input').focusin(function () {
    $('label[for^="'+$(this).attr('placeholder')+'"]').fadeIn();
  });
  $('.form-input').focusout(function () {
    $('label[for^="'+$(this).attr('placeholder')+'"]').hide();
  });
}

export function handleGravityForms() {
  const fieldInputs = [
    '.gform_fields input[type="text"]',
    '.gform_fields textarea',
    '.gform_fields input[type="tel"]',
    '.gform_fields input[type="url"]',
    '.gform_fields input[type="email"]',
    '.gform_fields input[type="number"]',
  ];

  $(fieldInputs.join(', ')).focusin(function () {
    $('label[for^="'+$(this).attr('id')+'"]').fadeIn();
  });
  $(fieldInputs.join(', ')).focusout(function () {
    $('label[for^="'+$(this).attr('id')+'"]').hide();
  });
}



// WEBPACK FOOTER //
// ./scripts/func/customForms.js